cac_data.openingHours = function () {
    cac_data.panels = cac_data.panels || {};
    cac_data.panels.openingHours = { panel: new Panel('openingHours', document.querySelector('.panel-container[data-panel-opening-hours]')) };
}
document.addEventListener("DOMContentLoaded", function (e) { cac_data.openingHours(); });